import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const triggerOrderTrackingBackfill = {
  name: "triggerOrderTrackingBackfill" as const,
  input: z.object({
    teamId: zExt.objectId(),
    days: z.number().int().positive(),
  }),
  output: z.object({
    success: z.boolean(),
    workflowId: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
